import {Component,EventEmitter,Input,OnInit,Output} from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { ModalController, ToastController } from "@ionic/angular";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CorrigendumUploadModel } from "src/app/model/CorrigendumUploadModel";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TenementExchangeOtpModel } from "src/app/model/TenementExchangeOtpModel";
import moment from "moment";
import { ExtendSurrenderService } from "src/app/services/extend-surrender.Service";
  
  @Component({
    selector: "app-modal",
    templateUrl: "./extend-data-modal.component.html",
    styleUrls: ["./extend-data-modal.component.scss"],
  })
  export class ExtendedSurrenderModalComponent implements OnInit {
    key: number;
    base64File: string;
    public uploadedDocument: string;
    public uploadedDocumentTimestamp: Date;
    public isFileUploaded: boolean = false;
    form: FormGroup = new FormGroup({});
    selectedFile: File;
    corrigendumName: string = "";
    isLoading = false;
    CorrigendumResponseModel: CorrigendumUploadModel;
    corrigendumFileNameSelect: string;
    pageMode: string;
    corrigendumBase64: string;
    isOtpVerify: boolean = false;
    pageHead: string = "Login";
    maskMobileNumber: string;
    maskMobileNumberForFirstAppli: string;
    maskMobileNumberForSecondAppli: string;
    luser: TenementExchangeOtpModel = new TenementExchangeOtpModel();
    @Input() aceeptanceDate: any;
    @Input() surrenderDate: any;
    @Input() data: any[]=[];
  
    isSubmitDisabled: boolean = false;
    isResendOtpButtonVisible: boolean = false;
    resendOtpIn: any = null;
    timerOn = true;
    minDate: Date;
    currentDate: Date = new Date();
    selectedFileName: string = '';
    isFileSelected = false;
    @Output() dataModal = new EventEmitter<string>();
  
    constructor(
      private modalCtrl: ModalController,
      private extendSurrenderService :ExtendSurrenderService,
      private router: Router,
      private _snackBar: MatSnackBar,
      private route: ActivatedRoute,
    
    ) {
      this.minDate = moment(this.currentDate).add("day").toDate();
    }
  
    ngOnInit() {
      this.isSubmitDisabled = false;
      console.log("data", this.data);

      this.form = new FormGroup({
        surrenderStartDate: new FormControl(null, [Validators.required,]),
        surrenderEndDate: new FormControl(null, [Validators.required,this.endDateAfterStartDate]),
        corrigendumFileName: new FormControl(null, Validators.required),
        otpValue: new FormControl(null,Validators.required)
      });
    }

    endDateAfterStartDate(control: FormControl): { [key: string]: boolean } | null {
      const startDate = control.root.get('surrenderStartDate')?.value;
      const endDate = control.value;
    
      if (startDate && endDate && endDate <= startDate) {
        return { endDateNotAfterStartDate: true };
      }
    
      return null;
    }

    saveAppliDetails() {
      if (!this.data || this.data.length === 0) {
        this._snackBar.open("No application data available", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        });
        return;
      }

      const applicationNos = this.data.map(item => item.applicationNo).join(', ');
      console.log("OTP Value:", this.form.value.otpValue);

      let payload: any = {
        applicationNo: applicationNos,
        surrenderStartDate:moment(this.form.value.surrenderStartDate).format("DD-MMM-YY hh.mm.ss.SSSSSSSSS A"), 
        surrenderEndDate:moment(this.form.value.surrenderEndDate).format("DD-MMM-YY hh.mm.ss.SSSSSSSSS A"),
        uploadedFileName: this.corrigendumBase64,
      };
  
      this.extendSurrenderService.updateSurrenderDtl(payload,this.form.value.otpValue).subscribe(
        (data: any) => {
          if (data.status == "SUCCESS") {
            this.onSaveApplicantDetails();
            this._snackBar.open("Date for Selected Application Updated Successfully", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "success-toast",
              duration: 3 * 1000,
            });
          }
          if (data.status == "FAILURE") {
              alert(data.errorMessage);
          }
        },
        (error) => {
          //alert("Invalid OTP");
          this._snackBar.open("Invalid username or password", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3 * 1000,
          });
        }
      );
    }
  
    cancel() {
      this.modalCtrl.dismiss(null, "cancel");
    }

    resetFilter() {
      // window.location.reload();
      this.modalCtrl.dismiss(null, "cancel");
    }
  
    back() {
      this.isOtpVerify = false;
      this.pageHead = "Login";
    }
  
    onSaveApplicantDetails() {
      this.modalCtrl.dismiss("submit");
    }
  
    async errorToast(errorMessage: string, dur?: number) {
      await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      });
    }
  
    async successToast(msg) {
      await this._snackBar.open(msg, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      });
    }
  
    get corrigendumDetails() {
      return this.form.get("corrigendumLst")["controls"];
    }

    validateAccStartDate() {
      return new Date(this.form.value.surrenderStartDate) > new Date() 
        && new Date(this.form.value.surrenderEndDate) < this.form.value.surrenderStartDate
        ? true
        : false;
    }
    
    onFileSelect(event) {
      console.log("this.selectedFile ",event.target.files[0]);
      this.selectedFile = event.target.files[0];
      if (this.selectedFile && this.isFileTypeAllowed(this.selectedFile.type)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.corrigendumBase64 = reader.result as string;
          this.form.get('corrigendumFileName')?.setValue(this.selectedFile.name);
          this.isFileSelected = true;
        };
        reader.readAsDataURL(this.selectedFile);
      } else {
        this.isFileSelected = false;
        this.form.get('corrigendumFileName')?.setValue(null);
        this.errorToast("Please select a valid PDF, PNG, JPG, or JPEG file.");
      }
    }

    isFileTypeAllowed(fileType: string): boolean {
      const allowedTypes = ["application/pdf","image/png","image/jpeg","image/jpg",];
      return allowedTypes.includes(fileType);
    }
    
    isVisibleOtpText:boolean=false;
    

    generateOtp(){
      this.isRegenerateOtp = false;
    this.timeLeft = 300; // reset the timer to 5 minutes
    this.startTimer();

      this.extendSurrenderService.generateOtp().subscribe(
          (data: any) => {
            if (data.status == "SUCCESS") {
              this.isVisibleOtpText=true;
            }
            if (data.status == "FAILURE") {
                alert(data.errorMessage);
            }
          },
          (error) => {
            alert("Invalid OTP");
          }
        );
     }

    timeLeft: number = 300; // 2 minutes in seconds
    isRegenerateOtp: boolean = false;
    timer: any;

    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
          //disable
          
        } else {
          this.isRegenerateOtp = true;
          this.stopTimer();
        }
      }, 1000);
    }

    stopTimer() {
      this.isRegenerateOtp = true;
      clearInterval(this.timer);
    }

  get timerDisplay() {
    const minutes: number = Math.floor(this.timeLeft / 60);
    const seconds: number = this.timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }
    numberOnly(event: any) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
  }
  